import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer>
        <p>© 2022 Amadou Dioubaté</p>
    </footer>
  )
}

export default Footer;